'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('body').append(`
        <div class="tooltip-overlay"></div>
        <div class="tooltip-popup">
            <div class="text-content"></div>
            <a class="close" href="#">Luk</a>
        </div>
    `);
    
    let tip = $('.tooltip-popup');   
    let overlay = $('.tooltip-overlay')

    $(scope).each(function(){
        let tipText = $(this).attr('title');

        $(this).removeAttr('title');
        $(this).data('title', tipText);

    }).on('click', function(){
        tip.find('.text-content').text($(this).data('title'));

        overlay.show();
        tip.show()

        return false;
    });

    tip.find('.close').on('click', function () {
        tip.hide();
        overlay.hide();
        return false;
    });

    overlay.on('click', function () {
        tip.find('.close').trigger('click');
        return false;
    });


}